<template>
  <div class="home-page">
    <!-- The background image for the homepage -->
    <div class="bg-image">
      <!-- You can add text or other content here if needed in the future -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<style scoped>
.home-page {
  width: 100%;
  height: 100vh; /* Full screen height */
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-image {
  background-image: url('@/assets/arminas_iraq_cover.jpeg'); /* Replace with your image path */
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  opacity: 0.8; /* Optional: Adjust opacity if you want to add some transparency */
}
</style>
